import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// Inner wrap the App.js router with this to get debug logging of route changes
const LogRoutes = ({ children }) => {
  const location = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    console.log("Route changed:", location.pathname);
  }, [location]);

  return children;
};

export default LogRoutes;
